<template>
  <div>
    <div class="d-flex justify-space-between">
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              class="m-l-10 cursor-pointer"
              :disabled="!isEnableBackward"
              @click="backward"
              small
            >
              fa-arrow-left
            </v-icon>
          </template>
          <span>Go back a page</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              class="m-l-10 cursor-pointer"
              :disabled="!isEnableForward"
              @click="forward"
              small
            >
              fa-arrow-right
            </v-icon>
          </template>
          <span>Go forward a page</span>
        </v-tooltip>
      </div>
      <v-menu :absolute="true">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-tooltip top>
              <template v-slot:activator="{ on: on2 }">
                <v-icon class="p-l-10 p-r-10" v-on="on2" small>
                  fa-plus-circle
                </v-icon>
              </template>
              <span>New page or folder</span>
            </v-tooltip>
          </div>
        </template>
        <v-list dense>
          <v-list-item
            v-for="(option, index) in rootOptions"
            :key="index"
            :class="option.divider ? 'menu-divider' : ''"
          >
            <v-list-item-content v-if="option.divider">
              <hr />
            </v-list-item-content>
            <v-list-item-content
              v-else
              class="cursor-pointer"
              @click="rootOptionClick(option.action)"
            >
              <v-list-item-subtitle
                :id="`list${index}`"
                class="font-size-body"
                >{{ option.title }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <sl-vue-tree
      ref="refSlTree"
      v-model="nodes"
      class="m-t-10 m-l-10 font-size-body page"
      :allowMultiselect="false"
      @beforedrop="beforedrop"
      @drop="drop"
    >
      <template slot="title" slot-scope="{ node }">
        <span>
          <!-- folder -->
          <span v-if="!node.isLeaf" class="m-l-4">
            <input
              type="text"
              class="page-rename"
              v-if="itemRename.pathStr === node.pathStr"
              :id="`folder-${node.data.id}`"
              :value="node.title"
              @blur="folderRename(node, true, $event)"
              @keyup.enter="folderRename(node, true, $event)"
              @keyup.esc.exact="folderRename(node, false, $event)"
            />
            <span
              v-else
              @click="folderExpanded(node)"
              @dblclick="folderDoubleClick(node)"
            >
              {{ node.title }}
            </span>
          </span>
          <!-- page -->
          <span
            v-else
            class="cursor-pointer"
            :class="node.title === tabSelected ? 'selected' : ''"
            @click="pageClick(node.title)"
          >
            <span v-if="node.title === 'Home'">
              <i class="fa fa-home m-r-2 page-icon-home"></i> {{ node.title }}
            </span>
            <span v-else>
              <input
                type="text"
                class="page-rename"
                v-if="itemRename.pathStr === node.pathStr"
                :id="`file-${node.data.id}`"
                :value="node.title"
                @blur="fileRename(node, true, $event)"
                @keyup.enter="fileRename(node, true, $event)"
                @keyup.esc.exact="fileRename(node, false, $event)"
              />
              <span v-else>
                <span class="div-icon">
                  <v-icon class="component-icon">far fa-file</v-icon>
                </span>
                <span @dblclick="fileDoubleClick(node)"> {{ node.title }}</span>
              </span>
            </span>
          </span>
        </span>
      </template>

      <template slot="toggle" slot-scope="{ node }">
        <span v-if="!node.isLeaf" class="folder-icon">
          <i v-if="node.isExpanded" class="far fa-folder-open page-icon"></i>
          <i v-if="!node.isExpanded" class="fas fa-folder page-icon"></i>
        </span>
      </template>

      <template slot="sidebar" slot-scope="{ node }">
        <v-icon
          v-if="!node.isLeaf || (node.isLeaf && node.title !== 'Home')"
          class="icon-warning visible-icon"
          :class="node.data && node.data.star ? 'visible' : 'invisible'"
        >
          fa fa-star
        </v-icon>
        <!-- page -->
        <span v-if="node.isLeaf">
          <v-menu :absolute="true" v-if="node.title !== 'Home'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                id="icon-dots"
                class="p-l-5 visible-icon"
                v-bind="attrs"
                v-on="on"
              >
                fa-ellipsis-v
              </v-icon>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(option, index) in pageOptions"
                :key="index"
                :class="option.divider ? 'menu-divider' : ''"
              >
                <v-list-item-content v-if="option.divider">
                  <hr />
                </v-list-item-content>
                <v-list-item-content
                  v-else
                  class="cursor-pointer"
                  @click="pageOptionClick(option.action, node)"
                >
                  <v-list-item-subtitle
                    :id="`list${index}`"
                    class="font-size-body"
                  >
                    {{ renameTitleOption(node, option.title) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <!-- folder -->
        <span v-else>
          <v-menu :absolute="true">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                id="icon-dots"
                class="p-l-5 visible-icon"
                v-bind="attrs"
                v-on="on"
              >
                fa-ellipsis-v
              </v-icon>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(option, index) in folderOptions"
                :key="index"
                :class="option.divider ? 'menu-divider' : ''"
              >
                <v-list-item-content v-if="option.divider">
                  <hr />
                </v-list-item-content>
                <v-list-item-content
                  v-else
                  :class="
                    option.action === 'delete_folder' &&
                    node.children &&
                    node.children.length > 0
                      ? 'disabled'
                      : 'cursor-pointer'
                  "
                  @click="folderOptionClick(option.action, node)"
                >
                  <v-list-item-subtitle
                    :id="`list${index}`"
                    class="font-size-body"
                  >
                    {{ renameTitleOption(node, option.title) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
      </template>
    </sl-vue-tree>

    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </div>
</template>

<script>
import _ from 'lodash'
import SlVueTree from 'sl-vue-tree'
const { v4: uuidv4 } = require('uuid')

import 'sl-vue-tree/dist/sl-vue-tree-minimal.css'

import Snackbar from '../../snackbar'

export default {
  components: {
    SlVueTree,
    Snackbar
  },
  props: {
    tabs: Array,
    structure: Array,
    tabSelected: String,
    isEnableBackward: Boolean,
    isEnableForward: Boolean
  },
  watch: {
    tabs: {
      immediate: true,
      deep: true,
      handler() {
        if (
          !this.structure ||
          (this.structure && this.structure.length === 0)
        ) {
          this.initStructure()
        }
      }
    },
    structure: {
      deep: true,
      handler() {
        const newData = _.cloneDeep(this.structure)
        this.nodes = this.sortingStructure(newData)

        // if (this.firstLoad) {
        //   this.nodes = this.collapseAllFolder(this.nodes)
        //   this.firstLoad = false
        // }
      }
    },
    tabSelected: {
      handler() {
        this.expandToPage(this.nodes, this.tabSelected, [])

        setTimeout(() => {
          const row = document.getElementsByClassName('selected')[0]
          const parent = document.querySelectorAll(
            '.page .sl-vue-tree-nodes-list'
          )[0]

          this.scrollParentToChild(parent, row)
        }, 100)
      }
    }
  },
  data() {
    return {
      // firstLoad: true,
      tempNodes: [],
      nodes: [],
      rootOptions: [
        { title: 'New blank page', action: 'new_page' },
        { title: 'From a template', action: 'clone_from_template' },
        { divider: true },
        { title: 'New folder', action: 'new_folder' }
      ],
      folderOptions: [
        { title: 'New blank page', action: 'new_page' },
        { title: 'From a template', action: 'clone_from_template' },
        { divider: true },
        { title: 'New folder', action: 'new_folder' },
        { title: 'Delete folder', action: 'delete_folder' },
        { divider: true },
        { title: 'star', action: 'star' }
      ],
      pageOptions: [
        { title: 'Save as template', action: 'save_template' },
        { title: 'Delete page', action: 'delete_page' },
        { divider: true },
        { title: 'star', action: 'star' }
      ],
      itemRename: {
        pathStr: '',
        title: ''
      },
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      }
    }
  },
  methods: {
    expandToPage(data, name) {
      for (let i = 0; i < data.length; i++) {
        // find in folder
        if (!data[i].isLeaf) {
          if (data[i] && data[i].children) {
            const str = JSON.stringify(data[i].children)

            if (str && str.indexOf(`"title":"${name}","isLeaf":true`) !== -1) {
              data[i].isExpanded = true

              this.expandToPage(data[i].children, name)
            }
          }
        }
      }
    },
    // collapseAllFolder(data) {
    //   for (let i = 0; i < data.length; i++) {
    //     if (!data[i].isLeaf) {
    //       data[i].isExpanded = false
    //     }
    //     if (data[i] && data[i].children) {
    //       data[i].children = this.collapseAllFolder(data[i].children)
    //     }
    //   }

    //   return data
    // },
    beforedrop() {
      this.tempNodes = [...this.nodes]
    },
    drop(node) {
      if (node && node[0] && node[0].title === 'Home' && node[0].isLeaf) {
        this.nodes = [...this.tempNodes]
        const data = this.sortingStructure(this.nodes)
        this.$emit('setupStructure', data)

        return
      }
      // check duplicate folder/page
      const isDuplicated = this.checkDuplicateName(this.nodes)
      if (isDuplicated) {
        this.nodes = [...this.tempNodes]
      }
      const data = this.sortingStructure(this.nodes)
      this.$emit('setupStructure', data)
    },
    initStructure() {
      let data = []
      for (const tab of this.tabs) {
        data.push({ title: tab.name, isLeaf: true, data: { id: tab.id } })
      }

      // let data = this.pages

      data = this.sortingStructure(data)
      this.$emit('setupStructure', data)
    },
    sortingStructure(data) {
      const home = []
      const findIndexHome = _.findIndex(data, { title: 'Home' })
      if (findIndexHome > -1) {
        home.push(data[findIndexHome])

        data.splice(findIndexHome, 1)
      }

      const result = this.sortingByTypeAndName(data)
      return [...home, ...result]
    },
    sortingByTypeAndName(data) {
      data = _.orderBy(
        data,
        ['isLeaf', data => data.title.toLowerCase()],
        ['asc', 'asc']
      )
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].children) {
          data[i].children = this.sortingByTypeAndName(data[i].children)
        }
      }

      return data
    },
    checkDuplicateName(data) {
      const uniqueValues = _.uniqBy(data, 'title')
      if (uniqueValues.length < data.length) {
        return true
      } else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children && this.checkDuplicateName(data[i].children))
            return true
        }
      }
      return false
    },
    newUniqName(group, name, order, isLeaf) {
      const newName = `${name} ${order}`

      const hasName = _.find(group, obj => {
        return (
          (obj.title &&
            obj.title.toLowerCase() === newName.toLowerCase() &&
            obj.isLeaf === isLeaf) ||
          (obj.name && obj.name.toLowerCase() === newName.toLowerCase())
        )
      })
      if (hasName) {
        return this.newUniqName(group, name, ++order, isLeaf)
      }

      return {
        title: newName,
        isLeaf: isLeaf,
        data: { id: uuidv4().replace(/-/g, '') }
      }
    },
    rootOptionClick(action) {
      switch (action) {
        case 'new_page':
          const newPage = this.newUniqName(this.tabs, 'New page', 1, true)
          this.nodes.push(newPage)

          this.$emit('pageCreate', {
            nodes: this.nodes,
            replaceId: newPage.data.id,
            name: newPage.title
          })
          break
        case 'clone_from_template':
          this.tempNodes = [...this.nodes]

          // insert new node
          const id = uuidv4().replace(/-/g, '')
          const clonePage = {
            title: id,
            isLeaf: true,
            data: { id }
          }

          this.nodes.push(clonePage)
          const newNode = [...this.nodes]

          // send new node but structure show current node
          this.nodes = [...this.tempNodes]
          this.$emit('pageCloneFromTemplate', {
            nodes: newNode,
            replaceId: id
          })

          break
        case 'new_folder':
          const newFolder = this.newUniqName(this.nodes, 'New folder', 1, false)
          this.nodes.push(newFolder)

          this.$emit('setupStructure', this.nodes)
          break
        default:
          break
      }
    },
    folderOptionClick(action, node) {
      switch (action) {
        case 'new_page':
          const newPage = this.newUniqName(this.tabs, 'New page', 1, true)

          const child1 = node.children || []
          child1.push(newPage)
          node.children = child1

          this.$refs.refSlTree.updateNode(node.path, node)

          this.$emit('pageCreate', {
            nodes: this.nodes,
            replaceId: newPage.data.id,
            name: newPage.title
          })
          break
        case 'clone_from_template':
          this.tempNodes = [...this.nodes]

          // insert new node
          const id = uuidv4().replace(/-/g, '')
          const clonePage = {
            title: id,
            isLeaf: true,
            data: { id }
          }

          const child2 = node.children || []
          child2.push(clonePage)
          node.children = child2
          this.$refs.refSlTree.updateNode(node.path, node)
          const newNode = [...this.nodes]

          // send new node but structure show current node
          this.nodes = [...this.tempNodes]
          this.$emit('pageCloneFromTemplate', {
            nodes: newNode,
            replaceId: id
          })

          break
        case 'new_folder':
          const newFolder = this.newUniqName(
            node.children,
            'New folder',
            1,
            false
          )
          node.children.push(newFolder)
          node.isExpanded = true
          this.$refs.refSlTree.updateNode(node.path, node)

          this.$emit('setupStructure', this.nodes)
          break
        case 'delete_folder':
          if (node.children && node.children.length > 0) return

          const nodes = []
          nodes.push(node.path)
          this.$refs.refSlTree.remove(nodes)

          this.$emit('setupStructure', this.nodes)
          break
        case 'star':
          if (node.data.star) this.removeStar(node)
          else this.addStar(node)

          break
        default:
          break
      }
    },
    pageOptionClick(action, node) {
      switch (action) {
        case 'save_template':
          const tab = _.find(this.tabs, { id: node.data.id })
          if (tab) this.$emit('pageSaveAsTemplate', tab)

          break
        case 'delete_page':
          this.tempNodes = [...this.nodes]

          // remove node
          const nodes = []
          nodes.push(node.path)
          this.$refs.refSlTree.remove(nodes)

          // send new node but structure show current node
          const newNode = [...this.nodes]
          this.nodes = [...this.tempNodes]
          const tab2 = _.find(this.tabs, { id: node.data.id })
          if (tab2)
            this.$emit('pageConfirmRemove', { nodes: newNode, tab: tab2 })

          break
        case 'star':
          if (node.data.star) this.removeStar(node)
          else this.addStar(node)

          break
        default:
          break
      }
    },
    backward() {
      this.$emit('backward', null)
    },
    forward() {
      this.$emit('forward', null)
    },
    pageClick(data) {
      this.$emit('pageClick', data)
    },
    folderExpanded(node) {
      node.isExpanded = !node.isExpanded
      this.$refs.refSlTree.updateNode(node.path, node)
    },
    folderDoubleClick(node) {
      this.itemRename.pathStr = node.pathStr
      this.itemRename.title = node.title

      setTimeout(() => {
        const div = document.getElementById(`folder-${node.data.id}`)
        if (div) div.focus()
      }, 100)
    },
    folderRename(node, isSave, event) {
      if (!event.sourceCapabilities) return

      const div = document.getElementById(`folder-${node.data.id}`)

      const oldName = this.itemRename.title
      const newName = div.value

      node.title = isSave && newName ? newName : oldName

      this.$refs.refSlTree.updateNode(node.path, node)

      if (isSave && newName) {
        const isDuplicated = this.checkDuplicateName(this.nodes)

        if (isDuplicated) {
          node.title = oldName
          this.$refs.refSlTree.updateNode(node.path, node)

          this.snackbar.colorSnackbar = 'error'
          this.snackbar.textSnackbar = `${newName} was already created`
          this.snackbar.open = true
        }
      }

      this.$emit('setupStructure', this.nodes)
      if (div) div.blur()

      this.itemRename = {
        pathStr: '',
        title: ''
      }
    },
    fileDoubleClick(node) {
      this.tempNodes = [...this.nodes]

      this.itemRename.pathStr = node.pathStr
      this.itemRename.title = node.title

      setTimeout(() => {
        const div = document.getElementById(`file-${node.data.id}`)
        if (div) div.focus()
      }, 100)
    },
    fileRename(node, isSave, event) {
      if (!event.sourceCapabilities) return

      const div = document.getElementById(`file-${node.data.id}`)

      const oldName = this.itemRename.title
      const newName = div.value

      node.title = isSave && newName ? newName : oldName

      if (isSave && newName) {
        if (oldName !== newName) {
          this.$refs.refSlTree.updateNode(node.path, node)

          const newNode = [...this.nodes]
          this.nodes = [...this.tempNodes]

          const hasPage = _.find(this.tabs, obj => {
            return (
              obj.id !== node.data.id &&
              obj.name.toLowerCase() === newName.toLowerCase()
            )
          })

          if (hasPage) {
            this.snackbar.colorSnackbar = 'error'
            this.snackbar.textSnackbar = `${newName} was already created`
            this.snackbar.open = true
          } else {
            this.$emit('pageRename', {
              pageId: node.data.id,
              oldName,
              newName,
              nodes: newNode
            })
          }
        }
      }
      if (div) div.blur()

      this.itemRename = {
        pathStr: '',
        title: ''
      }
    },
    addStar(node) {
      node.data.star = true

      this.$refs.refSlTree.updateNode(node.path, node)
      this.$emit('setupStructure', this.nodes)
    },
    removeStar(node) {
      node.data.star = undefined

      this.$refs.refSlTree.updateNode(node.path, node)
      this.$emit('setupStructure', this.nodes)
    },
    renameTitleOption(node, title) {
      if (title === 'star')
        if (node.data.star) return 'Remove star'
        else return 'Add star'

      return title
    },
    scrollParentToChild(parent, child) {
      // console.log(parent)
      // console.log(child)
      const parentRect = parent.getBoundingClientRect()
      const parentViewableArea = {
        height: parent.clientHeight,
        width: parent.clientWidth
      }
      const childRect = child.getBoundingClientRect()
      const isViewable =
        childRect.top >= parentRect.top &&
        childRect.top <= parentRect.top + parentViewableArea.height
      if (!isViewable) {
        parent.scrollTop =
          childRect.top + parent.scrollTop - parentRect.top - childRect.height
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .sl-vue-tree-root > .sl-vue-tree-nodes-list {
  max-height: calc(100vh - 220px);
  overflow-y: overlay;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }

  .sl-vue-tree-node {
    line-height: 2;
  }
}

::v-deep .sl-vue-tree-sidebar {
  width: 30px;
  margin-right: 3px;
}

::v-deep .sl-vue-tree-selected .sl-vue-tree-node-item {
  background: none !important;
}

.folder-icon {
  display: inline-block;
  width: 13px;
  text-align: center;
}

.page-icon-home {
  font-size: 14px;
}

.page-icon {
  font-size: 15px;
}

.selected {
  font-weight: 700;
  color: $primary !important;

  .v-icon {
    color: $primary !important;
  }
}

.visible-icon {
  font-size: 14px;

  &.visible {
    visibility: visible;
  }

  &.invisible {
    visibility: hidden;
  }
}

.disabled {
  opacity: 0.5;
}

input.page-rename {
  height: 25px;
  margin-right: 15px;
  padding: 0 10px;
  width: 120px;
  color: $text-color;
  font-weight: 400;
}

.div-icon {
  display: inline-block;
  width: 16px;
  text-align: center;
}

.component-icon {
  font-size: 16px;
}
</style>
